<template>
  <div class="menu-side">
    <div>
      <img class="icon-back" src="../../assets/imgs/icon_back_white.png" alt="" @click="onClose">
    </div>
    <div class="menu-side-content">
      <div class="menu-side-title">
        <img src="../../assets/imgs/avatar.png" alt="">
        <span v-if="user && user.pname">{{ user.pname | decode }}</span>
        <span v-else @click="goRouter('/login')">{{ i18n.login_tips }}</span>
      </div>
      <!-- <div class="menu-side-row" @click="goRouter('/shop')">
      <img src="../../assets/imgs/shop.png" alt="">
      <span>{{i18n.buy}}</span>
    </div> -->
      <!-- <div class="menu-side-row">
      <img src="../../assets/imgs/coupon.png" alt="">
      <span>优惠券</span>
    </div> -->
      <div class="menu-side-foot">
        <div class="menu-side-row" @click="goRouter('/order')">
          <!-- <img src="../../assets/imgs/history.png" alt=""> -->
          <span>{{ i18n.order }}</span>
        </div>
        <div class="menu-side-row" @click="goRouter('/wallet')">
          <!-- <img src="../../assets/imgs/wallet.png" alt=""> -->
          <span>{{i18n.wallet}}</span>
        </div>
        <div class="menu-side-row" @click="goRouter('/setting')">
          <!-- <img src="../../assets/imgs/setting.png" alt=""> -->
          <span>{{ i18n.setting }}</span>
        </div>
        <div class="menu-side-row" @click="goRouter('/help')">
          <!-- <img src="../../assets/imgs/help.png" alt=""> -->
          <span>{{ i18n.help }}</span>
        </div>
        <div class="menu-side-row" @click="onLogout">
          <!-- <img src="../../assets/imgs/logout.png" alt=""> -->
          <span>{{ i18n.logout }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['user']),
    i18n() {
      return this.$t('mine')
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    onLogout() {
      this.$store.commit('user', null)
      this.$store.commit('token', '')
      this.$router.push('/login')
    },
    goRouter(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="less">
@mainColor: #8568AA;
.menu-side {
  width: 100vw;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100vh;
  background: @mainColor;
  .icon-back {
    display: block;
    margin: 48px 0 0 48px;
    width: 80px;
  }
  &-content {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top-left-radius: 80px;
    border-top-right-radius: 80px;
    background: #F1F1F1;
  }

  &-title {
    font-size: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 180px;
      height: 180px;
      border-radius: 50%;
      margin: -15% 24px 10px 48px;
    }
  }

  &-row {
    font-size: 32px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100px;
    padding-left: 80px;

    img {
      width: 40px;
      height: 40px;
      margin: 0 24px 0 68px;
    }
  }

  &-foot {
    background: #fff;
    margin: 20px 40px 60%;
    box-sizing: border-box;
    border-radius: 20px;
    // position: absolute;
    // bottom: 48px;
  }
}
</style>
